import React from "react"
import styled, { keyframes } from "styled-components"

import { ReactComponent as SpinnerSVG } from "../Icons/Spinner.svg"

interface Props {
  className?: string
}

const spinnerHeight = 40
const verticalMargin = 40

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const SpinnerContainer = styled(SpinnerSVG)`
  animation: ${rotate} 2s linear infinite;
  display: block;
  height: ${spinnerHeight}px;
  margin: ${verticalMargin}px auto;
  width: ${spinnerHeight}px;
`

const Spinner = (props: Props) => <SpinnerContainer {...props} />

export default Spinner
